var backArrowIcon = "\n<svg width=\"17\" height=\"18\" xmlns=\"http://www.w3.org/2000/svg\">\n  <g stroke=\"#00234B\" stroke-width=\"2\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n    <path d=\"M9 17L1 8.998 8.995 1M15.462 9H2\"/>\n  </g>\n</svg>";

export { backArrowIcon as default };
